import { css } from "@emotion/react";
import React from "react";

type Props = {
  children: React.ReactNode;
};

export const UserTableCellWrapText = (props: Props) => {
  return <div css={wrapText}>{props.children}</div>;
};

const wrapText = css({
  wordBreak: "break-all",
  padding: "8px 0",
});
